const INITIAL_STATE = {
  franchiseList: [],
  revenueReport: {},
  zipcodeList: {},
  typeList:{},
  errors: {},
}
  
const revenueReport = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_REVENUE_REPORT_FRANCHISE_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, franchiseList: action.data }
  case 'GET_REVENUE_REPORT_FRANCHISE_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'GET_REVENUE_REPORT_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, revenueReport: action.data }
  case 'GET_REVENUE_REPORT_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'GET_REVENUE_REPORT_BY_ID_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, revenueReport: action.data }
  case 'GET_REVENUE_REPORT_BY_ID_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'GET_REPORT_ZIPCODE_LIST_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, zipcodeList: action.data }
  case 'GET_REPORT_ZIPCODE_LIST_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'GET_REPORT_TYPE_LIST_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, typeList: action.data }
  case 'GET_REPORT_TYPE_LIST_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
        
export default revenueReport;